import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const getListByFirm = ({
                                cityID = -1,
                                streetID = -1,
                                gush = '',
                                helka = '',
                                fromDate = '',
                                toDate = '',
                                customerName = "",
                                shumaID = -1,
                                shumaTypeID = -1,
                                propertyTypeID = -1,
                                responsibleUserID = -1,
                                statusTypeID = -1,
                                fromRoomCount = -1,
                                toRoomCount = -1,
                                fromRegisteredArea = -1,
                                toRegisteredArea = -1,
                                elevator = -1,
                                requestedPageNumber = 0
                              }) => dispatch => {
  dispatch({
    type: A.GET_INSPECTIONS_BY_FIRM_LIST
  });

  const data = {
    cityID,
    streetID,
    gush,
    helka,
    fromDate,
    toDate,
    customerName,
    shumaID,
    shumaTypeID,
    propertyTypeID,
    responsibleUserID,
    statusTypeID,
    fromRoomCount,
    toRoomCount,
    fromRegisteredArea,
    toRegisteredArea,
    elevator,
    requestedPageNumber,
  };

  return axios.post(api.GET_LIST_BY_FIRM, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {inspections, totalPageCount, currentPageNumber, totalResultCount} = body;
      dispatch({
        type: A.GET_INSPECTIONS_BY_FIRM_LIST_SUCCESS,
        payload: {list: inspections, totalPages: totalPageCount, totalResultCount},
      });
      dispatch({
        type: A.SET_INSPECTIONS_BY_FIRM_PAGE,
        payload: {page: currentPageNumber}
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_INSPECTIONS_BY_FIRM_LIST_FAILURE,
        payload: err.message
      })
    });
};
